import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { fetchAppDetails } from "../../Services/AppService";

const Download = () => {
  const [appDetails, setAppDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadAppDetails();
  }, []);

  const loadAppDetails = async () => {
    try {
      const response = await fetchAppDetails();
      if (response.error) {
        throw new Error(response.error);
      }

      setAppDetails(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="download" className="py-5 bg-light">
      <div className="container py-5">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-5 mb-lg-0">
            <h2 className="section-title d-inline-block">Download APK</h2>

            {error && (
              <div className="alert alert-warning">
                Couldn't connect to server. Showing cached version info.
              </div>
            )}

            {appDetails && (
              <div>
                <p className="lead mb-4">
                  Get the latest version of Formax Pay directly from our server
                </p>

                <div className="mb-4">
                  <h4>Version {appDetails.latest_version}</h4>
                  <p>
                    <i className="fas fa-file-archive mr-2"></i> File size:{" "}
                    {appDetails.apk_size}
                  </p>
                  <p>
                    <i className="fas fa-fingerprint mr-2"></i> SHA-256:{" "}
                    {appDetails.apk_hash}
                  </p>
                  <p>
                    <i className="fas fa-calendar-alt mr-2"></i> Last updated:{" "}
                    {appDetails.last_updated_on}
                  </p>
                </div>

                <a
                  href={appDetails.app_url}
                  className="btn btn-primary btn-lg px-5 py-3 mb-3"
                  download
                >
                  <i className="fas fa-download mr-2"></i>Download Now
                </a>
              </div>
            )}

            <div className="mt-4">
              <p className="small text-muted">
                By downloading, you agree to our{" "}
                <a
                  href="https://www.formaxpay.com/terms-and-conditions"
                  target="_blank"
                >
                  Terms of Service
                </a>{" "}
                and{" "}
                <a
                  href="https://www.formaxpay.com/refund-policy"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>
          <div className="col-lg-6 text-center">
            <div className="qr-container mb-4">
              {appDetails && (
                <div>
                  <QRCodeSVG
                    value={appDetails.app_url}
                    size={200}
                    level="H" // Error correction level (L, M, Q, H)
                    includeMargin={true}
                  />
                  <p className="mt-2 mb-0">Scan to download</p>
                </div>
              )}
            </div>

            <div className="installation-steps mt-5">
              <h5 className="mb-4">Installation Guide</h5>
              <div className="d-flex mb-3">
                <div className="step-number">1</div>
                <div className="text-left">
                  <h6>Enable Unknown Sources</h6>
                  <p className="mb-0 small">
                    Settings {">"} Security {">"} Install unknown apps
                  </p>
                </div>
              </div>
              <div className="d-flex mb-3">
                <div className="step-number">2</div>
                <div className="text-left">
                  <h6>Download the APK</h6>
                  <p className="mb-0 small">
                    Click the download button or scan QR code
                  </p>
                </div>
              </div>
              <div className="d-flex">
                <div className="step-number">3</div>
                <div className="text-left">
                  <h6>Install & Open</h6>
                  <p className="mb-0 small">
                    Open the downloaded file and follow instructions
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;
